import { render, staticRenderFns } from "./subordianteheader.vue?vue&type=template&id=5f148afe&scoped=true"
import script from "./subordianteheader.vue?vue&type=script&lang=js"
export * from "./subordianteheader.vue?vue&type=script&lang=js"
import style0 from "./subordianteheader.vue?vue&type=style&index=0&id=5f148afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f148afe",
  null
  
)

export default component.exports